const body = document.body;
const toggleBtn = document.querySelector("#main-nav-toggle");
const toggleBtnSrText = toggleBtn.querySelector("#header__main-nav-toggle__text");
const toggledClassName = "main-nav-toggled";
const mainNavContainer = document.querySelector("#main-nav-container");
const mainNav = document.querySelector("#main-nav");

// Add eventlistener to main nav toggle if it exists
toggleBtn?.addEventListener("click", (e) => {
    // Check if main nav is currently toggled by checking `<body />` for specifi class name
    const mainNavToggled = body.classList.contains(toggledClassName);

    if (mainNavToggled) {
        // Close nav
        body.classList.remove(toggledClassName);
        body.classList.remove("overflow-hidden"); // hide overflow of body to prevent scrolling
        toggleBtn.classList.remove("is-active");
        toggleBtn.setAttribute("title", "Hauptnavigation einblenden");
        if (toggleBtnSrText) toggleBtnSrText.innerHTML = "Hauptnavigation einblenden";
        if (mainNavContainer) mainNavContainer.style.maxHeight = 0;
        // Remove focus from event target
        e.target.blur();
        // Hide overflow of main nav for duration of transiton to prevent visible scroll bar
        if (mainNav) {
            mainNav.classList.add("overflow-hidden");
            window.setTimeout(() => {
                mainNav.classList.remove("overflow-hidden");
            }, 250);
        }
    } else {
        // Open nav
        body.classList.add(toggledClassName);
        body.classList.add("overflow-hidden"); // show overflow of body to enable scrolling
        toggleBtn.classList.add("is-active");
        toggleBtn.setAttribute("title", "Hauptnavigation ausblenden");
        if (toggleBtnSrText) toggleBtnSrText.innerHTML = "Hauptnavigation ausblenden";
        if (mainNavContainer) mainNavContainer.style.maxHeight = `100%`;
        // Hide overflow of main nav for duration of transiton to prevent visible scroll bar
        if (mainNav) {
            mainNav.classList.add("overflow-hidden");
            window.setTimeout(() => {
                mainNav.classList.remove("overflow-hidden");
            }, 250);
        }
    }

});